import React, { useState } from "react";
import './Admin.css';
import RTEditor from '../../utils/RTEditor';
import { saveConferenceInfo } from "../../services/ConferenceInformation";
import Alert from "@mui/material/Alert";
import ErrorIcon from "@mui/icons-material/Error";
import CheckIcon from "@mui/icons-material/Check";
export default function StaffDescription({ conferenceInfo, onConferenceInfoUpdate }: { conferenceInfo: any, onConferenceInfoUpdate: () => void }) {
  const [isShowAlert, setShowAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const handleSave = async (editorContent: string) => {
    if (conferenceInfo?.StaffDescription !== editorContent) {
      if (conferenceInfo !== undefined) {
        try {
          conferenceInfo.StaffDescription = editorContent;
          await saveConferenceInfo(conferenceInfo);
          onConferenceInfoUpdate();
          setSuccessMessage('Staff Description was successfully saved.');
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
            setSuccessMessage('');
          }, 5000);
        } catch (error) {
          setErrorMessage('Error saving Staff Description.');
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
            setErrorMessage('');
          }, 5000);
        }
      }
    }
  };
  return (
    <div className="Margin">
      {isShowAlert && successMessage && (
        <Alert  icon={<CheckIcon fontSize="inherit" />} severity="success">
          {successMessage}
        </Alert>
      )}
      {isShowAlert && errorMessage && (
        <Alert severity="error" icon={<ErrorIcon fontSize="inherit" />}>
          {errorMessage}
        </Alert>
      )}
      <div className="EditorContainer">
        <RTEditor editorName={"Staff Description"}
          content={conferenceInfo?.StaffDescription}
          saveContent={handleSave} />
        
      </div>
    </div>
  );
}
